import $ from "jquery";
import './App/Polyfills/CustomEventPolyfill';
import { ObjectFitModule } from './App/ObjectFitModule';
import { ParticlesModule } from './App/ParticlesModule';
import { MenuModule } from './App/MenuModule';
import { FooterMenuModule } from './App/FooterMenuModule';
import { SearchModule } from './App/SearchModule';
import { GraphModule } from './App/GraphModule';
import { VehicleDisclaimerModule } from './App/VehicleDisclaimerModule';
import { ExpandContentModule } from './App/ExpandContentModule';
import { AOSModule } from './App/AOSModule';
import { LottieModule } from './App/LottieModule';
import { MapModule } from './App/MapModule';
import { CookieDisclaimer } from './App/CookieDisclaimer';
import { TagManagerModule } from './App/TagManagerModule';
import { CookieSettingsModule } from './App/CookieSettingsModule';

$(document).ready(() => {
    let tagManagerModule = new TagManagerModule();
    tagManagerModule.dispatchEventsOnPageLoad();

    let objectFitModule = new ObjectFitModule();
    let particlesModule = new ParticlesModule();
    let menuModule = new MenuModule();
    menuModule.init();
    let searchModule = new SearchModule(menuModule);
    searchModule.init();
    let graphModule = new GraphModule();
    graphModule.init();
    let footerMenuModule = new FooterMenuModule();
    let vehicleDisclaimerModule = new VehicleDisclaimerModule();
    let expandContentModule = new ExpandContentModule();
    let aOSModule = new AOSModule();
    let lottieModule = new LottieModule();
    let mapModule = new MapModule();
    let cookieDisclaimer = new CookieDisclaimer();
    let cookieSettingsModule = new CookieSettingsModule();
});



// WEBPACK FOOTER //
// ./www/wp-content/themes/lynx-hedge/assets/scripts/src/index.js